const getters = {
  roles: (state) => state.userVUEX.roles,
  permission_routes: (state) => state.permission.routes,
  landingPage: (state) => state.userVUEX.roleValues,
  getaccess: (state) => state.userVUEX.token,
  // checkLoginStatus: (state) => state.userVUEX.loggedin,
};

export default getters;
